<template>
    <div v-if="isAuth" class="login-btn">
        <button @click="logout" class="btn btn-primary">Log out</button>
    </div>
    <div v-else class="login-btn">
        <a :href="$getSubdomainLink('portal', '/login')" class="btn btn-primary">Log in</a>
    </div>
</template>

<script>
import { useAuthStore } from "@/stores";
export default {
    data() {
        return {
            authStore: useAuthStore(),
        };
    },
    methods: {
        logout() {
            this.authStore.logout();
        },
    },
    computed: {
        isAuth() {
            return this.authStore.isAuth;
        },
    },
};
</script>